module.exports = __webpack_public_path__ + "static/img/patho-neoplasia-item-DytluiRf.9633c5dd.png";